<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  AppstoreOutlined,
  CreditCardOutlined,
  DownOutlined,
  DollarCircleOutlined,
  GoogleOutlined,
  KeyOutlined,
  LogoutOutlined,
  PayCircleOutlined,
  TeamOutlined,
  UserOutlined,
  WalletOutlined
} from "@ant-design/icons-vue";
import { useAdminAuthStore } from "../stores/adminAuth";

const router = useRouter();
const route = useRoute();
const adminAuth = useAdminAuthStore();

const navItems = [
  { key: "/admin/users", label: "用户管理", icon: UserOutlined },
  { key: "/admin/orders", label: "订单管理", icon: WalletOutlined },
  { key: "/admin/payment-products", label: "套餐管理", icon: CreditCardOutlined },
  { key: "/admin/pet-actions", label: "动作管理", icon: AppstoreOutlined },
  { key: "/admin/settings/wechat-merchant", label: "微信商户号", icon: PayCircleOutlined },
  { key: "/admin/settings/wechat-auth", label: "微信登录", icon: PayCircleOutlined },
  { key: "/admin/settings/stripe", label: "Stripe 支付", icon: DollarCircleOutlined },
  { key: "/admin/settings/google", label: "Google 登录", icon: GoogleOutlined },
  { key: "/admin/settings/registration-limits", label: "注册限制", icon: TeamOutlined },
  { key: "/admin/settings/jimeng", label: "即梦 API", icon: KeyOutlined }
];

const selectedKeys = computed(() => [route.path]);
const activeTitle = computed(() => navItems.find((item) => item.key === route.path)?.label ?? "运营后台");

async function onMenuClick(event: { key: string }) {
  await router.push(event.key);
}

async function onAccountMenuClick(event: { key: string }) {
  if (event.key === "logout") {
    await logout();
  }
}

async function logout() {
  adminAuth.logout();
  await router.push("/admin/login");
}
</script>

<template>
  <a-layout class="admin-app-shell">
    <a-layout-sider class="admin-app-sider" :width="248">
      <RouterLink class="admin-app-brand" to="/admin/users">
        <img class="admin-app-brand__mark" src="/brand-logo.png" alt="" aria-hidden="true" />
        <span>
          <strong>Autumn Pet</strong>
          <small>Admin Console</small>
        </span>
      </RouterLink>

      <a-menu
        class="admin-app-menu"
        mode="inline"
        :selected-keys="selectedKeys"
        @click="onMenuClick"
      >
        <a-menu-item v-for="item in navItems" :key="item.key">
          <component :is="item.icon" />
          <span>{{ item.label }}</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>

    <a-layout>
      <a-layout-header class="admin-app-header">
        <div>
          <a-typography-text type="secondary">Autumn Pet 运营控制台</a-typography-text>
          <a-typography-title :level="3">{{ activeTitle }}</a-typography-title>
        </div>
        <a-dropdown :trigger="['click']">
          <button class="admin-account-button" type="button">
            <span>{{ adminAuth.email }}</span>
            <DownOutlined />
          </button>
          <template #overlay>
            <a-menu class="admin-account-menu" @click="onAccountMenuClick">
              <a-menu-item key="logout">
                <LogoutOutlined />
                <span>退出登录</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </a-layout-header>

      <a-layout-content class="admin-app-content">
        <RouterView />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
